export default function HWY_Events() {
    const selectors = {
        button : ".load-more-button",
        currentPage: ".load-more-current-page",
        totalPage: ".load-more-total-page",
        wrapEvent: ".events-wrap .list-event",
        hidden: ".load-more",
        loading: '.load-more-waiting'
    };

    this.init = () => {
        triggerLoadMore();
    }

    const getCurrentPage = () => {
        return Number( document.querySelector( selectors.currentPage ).getAttribute("data-current-paged") );
    }

    const setCurrentPage = ( currentPaged, postsShowed ) => {
        document.querySelector( selectors.currentPage ).setAttribute("data-current-paged", currentPaged);
        document.querySelector( selectors.currentPage ).innerText = currentPaged * postsShowed;
        if( currentPaged === getTotalPage() ) {
            document.querySelector( selectors.hidden ).remove();
        }
    }

    const getTotalPage = () => {
        return Number( document.querySelector( selectors.totalPage ).getAttribute("data-total-paged") );
    }

    const renderHTML = ( html ) => {
        document.querySelector( selectors.wrapEvent ).innerHTML += html;
    }
    
    const controlLoading = ( status ) => {
        if( 'open' === status ) {
            document.querySelector( selectors.loading ).classList.add( 'loading' );
        } else {
            document.querySelector( selectors.loading ).classList.remove( 'loading' );
        }
    }

    const triggerLoadMore = () => {
        if( null == document.querySelector( selectors.button ) ) return;
        document.querySelector( selectors.button ).addEventListener( 'click', () => {
            const data = {
                'action': 'event_post_load_more',
                'load_page': getCurrentPage() + 1,
            }
            
            jQuery.ajax({
                type: 'GET',
                dataType: "json",
                url: theme_object.ajax_url,
                data,
                beforeSend: function () {
                    controlLoading( 'open' );
                },
                success: function ( response ) {
                    renderHTML( response.html );
                    controlLoading( 'close' );
                    setCurrentPage( Number( response.loadPage ), Number( response.postShowed ) );
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log(
                      "The following error occured: " + textStatus,
                      errorThrown
                    );
                  },
            })

        } );
    }
}